import {APIRegistry} from '@spothero/utils/api';

export const v2serviceInstance = () => APIRegistry.get('v2serviceInstance');
